import * as ActionTypes from '../../actions/actionTypes'

const initialState = {
    pendingPushYearPrices: false,
    pendingPushYearRestrictions: false,
    pendingPushYearAvailability: false,
    pendingInventoryAvailability: false,
    pendingInventoryOrder: false
}

/** @reducer **/
export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.EXPEDIA_PUSH_YEAR_PRICES_REQUEST:
            return { ...state, pendingPushYearPrices: true }
        case ActionTypes.EXPEDIA_PUSH_YEAR_PRICES_SUCCESS:
        case ActionTypes.EXPEDIA_PUSH_YEAR_PRICES_FAILURE:
            return { ...state, pendingPushYearPrices: false }

        case ActionTypes.EXPEDIA_PUSH_YEAR_RESTRICTIONS_REQUEST:
            return { ...state, pendingPushYearRestrictions: true }
        case ActionTypes.EXPEDIA_PUSH_YEAR_RESTRICTIONS_SUCCESS:
        case ActionTypes.EXPEDIA_PUSH_YEAR_RESTRICTIONS_FAILURE:
            return { ...state, pendingPushYearRestrictions: false }

        case ActionTypes.EXPEDIA_PUSH_YEAR_AVAILABILITY_REQUEST:
            return { ...state, pendingPushYearAvailability: true }
        case ActionTypes.EXPEDIA_PUSH_YEAR_AVAILABILITY_SUCCESS:
        case ActionTypes.EXPEDIA_PUSH_YEAR_AVAILABILITY_FAILURE:
            return { ...state, pendingPushYearAvailability: false }

        case ActionTypes.EXPEDIA_INVENTORY_AVAILABILITY_REQUEST:
            return { ...state, pendingInventoryAvailability: true }
        case ActionTypes.EXPEDIA_INVENTORY_AVAILABILITY_SUCCESS:
        case ActionTypes.EXPEDIA_INVENTORY_AVAILABILITY_FAILURE:
            return { ...state, pendingInventoryAvailability: false }

        case ActionTypes.EXPEDIA_INVENTORY_ORDER_REQUEST:
            return { ...state, pendingInventoryOrder: true }
        case ActionTypes.EXPEDIA_INVENTORY_ORDER_SUCCESS:
        case ActionTypes.EXPEDIA_INVENTORY_ORDER_FAILURE:
            return { ...state, pendingInventoryOrder: false }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/expediaReducers/expediaSync.js